import React, { FC } from "react";
import icon from "../../../../assets/svg/ShowMoreMenu.svg";

const SettingsIcon: FC = () => {
    return (
        <img src={icon} alt="show more menu" style={{maxWidth: 40, objectFit: "contain"}}/>
    );
}

export default SettingsIcon;